import dayjs from "dayjs";
import { CreateUpload } from "@coworker/apprestructured/src/task-management/types/Upload";
import { SignedUrlResponse } from "@coworker/apprestructured/src/task-management/services/uploads.service";
import { TFunction } from "../../../packages/locales/translations/util/useTranslation";

/**
 * 2025-08-26T12:50:05.251Z -> 2025-08-26 14:50
 * @param iso timestamp in UTC
 * @returns formatted string in user timezone
 */
export function formatDateTime(iso: string) {
  const date = new Date(Date.parse(iso));
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}

/**
 * 2025-08-26T12:50:05.251Z -> 2025-08-26
 * @param iso timestamp in UTC
 * @returns formatted string in user timezone
 */
export function formatDate(iso: string) {
  const date = new Date(Date.parse(iso));
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

/**
 * Convert a list of files into a list of CreateUpload.
 * Each File#name must have a corresponding WriteSignedUrlResponse#originalFileName.
 *
 * @param files the files to convert
 * @param signedUrlResponses signed urls for all files
 */
export function filesToCreateUploads(
  files: File[],
  signedUrlResponses: SignedUrlResponse[]
): CreateUpload[] {
  return files.map((file) => {
    const bucket_id =
      signedUrlResponses.find(
        ({ originalFileName }) => originalFileName === file.name
      )?.fileName || null;

    if (bucket_id === null) {
      throw new Error(`No signed url exists for file '${file.name}'`);
    }

    return {
      name: file.name,
      size: file.size,
      bucket_id,
    };
  });
}

/**
 * Result will be correctly negative for future dates.
 * @param date e.g. '2026-02-23'
 */
export function calcDaysOverdue(date: string) {
  return dayjs().startOf("day").diff(dayjs(date), "day");
}

/**
 * Only gives a valid result if daysOverdue > 0.
 */
export function calcOverdueString(daysOverdue: number, t: TFunction) {
  if (daysOverdue === 1) {
    return t("oneDayOverdueString");
  } else {
    return t("daysOverdueString", { daysOverdue });
  }
}
